<template lang="pug">
.curso-main-container.introduccion
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
  
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero
        span
          i.fas.fa-info.text-white
      h1 Introducción
    
    p.mb-5 Se da inicio a este componente con un vídeo donde se presentan aspectos importantes a tener en cuenta para el desarrollo del mismo, haciendo una breve introducción al concepto de interfaces web y los medios donde se ejecutan, vamos a conocerlo, bienvenidos:
    
    
    figure.mb-5
      .video
        <iframe width="950" height="534" src="https://www.youtube.com/embed/1fT5SGzQDAM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      
    

    
</template>

<script>
export default {
  name: 'Introduccion',
  data: () => ({
    // variables de vue
  }),
}
</script>

<style lang="sass"></style>
